<lns-card [cardType]="cardType.White" [navigations]="navigations">
  <ng-container *ngIf="accountData">
    <lns-card-dropdown
      *ngIf="navigations.length"
      [navigations]="navigations"
      [account]="accountData"
      [showLeft]="child == index + 1"
    ></lns-card-dropdown>
    <div fxLayoutAlign="start start" class="title-height">
      <div
        class="dot p-3"
        [ngStyle]="{ backgroundColor: accountData.color }"
      ></div>
      <div>
        <p class="title pointer" (click)="navigateToAccountDetails()">
          {{ accountData.accountName }}
        </p>
        <p class="subtitle text-gray">{{ accountData.accountIban || '-' }}</p>
      </div>
    </div>
    <div class="lineChart">
      <lns-line-chart
        class="pointer"
        [balance]="
          accountData.accountType.includes('CURRENT_ACCOUNT') ||
          accountData.accountType.includes('CURRENT_PROXY_ACCOUNT')
            ? accountData.activeBalance
            : ''
        "
        [color]="accountData.color"
        (click)="navigateToAccountTransactionHistory()"
      ></lns-line-chart>
      <div class="lineChart__labels" fxLayoutAlign="space-between center">
        <ng-container
          *ngIf="accountData.accountType.includes('CURRENT_ACCOUNT')"
        >
          <ng-container>
            <span *ngFor="let month of lastFourMonths">{{
              month | translate
            }}</span>
          </ng-container>
        </ng-container>
        <ng-container
          *ngIf="
            !accountData.accountType.includes('CURRENT_ACCOUNT') ||
            accountData.accountType.includes('CURRENT_PROXY_ACCOUNT')
          "
          ><span class="opacity-0">{{ '-' }}</span>
        </ng-container>
      </div>
    </div>

    <!-- CURRENT_ACCOUNT -->
    <ng-container
      *ngIf="
        accountData.accountType.includes('CURRENT_ACCOUNT') ||
        accountData.accountType.includes('CURRENT_PROXY_ACCOUNT')
      "
    >
      <div
        class="currency"
        fxLayout="row"
        fxLayoutGap="10px"
        (wheel)="onLabelsScroll($event)"
        #labels
      >
        <ng-container>
          <ng-container>
            <p
              *ngFor="let balance of accountData.balances"
              [ngClass]="{
                'currency--active':
                  accountData.activeBalance?.currency === balance.currency
              }"
              (click)="changeCurrency(balance)"
            >
              {{ balance.currency }}
            </p>
            <p
              *ngFor="let balance of accountData.balance"
              [ngClass]="{
                'currency--active':
                  accountData.currency === balance.currency || balance.currency
              }"
              (click)="changeCurrency(balance)"
            >
              {{ balance.currency }}
            </p>
          </ng-container>
        </ng-container>
      </div>

      <div class="price" fxLayoutAlign="start center" fxLayoutGap="8px">
        <div
          [lnsAccountBalance]="
            accountData.activeBalance
              ? accountData.activeBalance?.amount
              : accountData.totalAmount
          "
          class="price__value"
        ></div>
        <span class="price__currency">{{
          accountData.activeBalance
            ? accountData.activeBalance?.currency
            : accountData.currency
        }}</span>
      </div>
      <div class="font-14 text-gray mb-12 mt-n8">
        {{ 'dashboard__account_available_balance' | translate }}
      </div>
    </ng-container>

    <!-- LOAN_ACCOUNT -->
    <ng-container *ngIf="accountData.accountType.includes('LOAN_ACCOUNT')">
      <div
        class="currency"
        fxLayout="row"
        fxLayoutGap="10px"
        (wheel)="onLabelsScroll($event)"
        #labels
      >
        <ng-container>
          <p
            [ngClass]="{
              'currency--active': selectedCreditTab == 0
            }"
            (click)="changeCredit(0)"
          >
            {{ 'loans_unmatured' | translate | uppercase }}
          </p>
          <p
            [ngClass]="{
              'currency--active': selectedCreditTab == 1
            }"
            (click)="changeCredit(1)"
          >
            {{ 'loans_total' | translate | uppercase }}
          </p>
          <p
            [ngClass]="{
              'currency--active': selectedCreditTab == 2
            }"
            (click)="changeCredit(2)"
          >
            {{ 'loans_details_annuity' | translate | uppercase }}
          </p>
        </ng-container>
      </div>
      <div
        class="price"
        fxLayoutAlign="start center"
        fxLayoutGap="8px"
        *ngIf="selectedCreditTab == 1"
      >
        <div
          [lnsAccountBalance]="accountData.totalAmount"
          class="price__value"
        ></div>
        <span class="price__currency">{{ accountData.currency }}</span>
      </div>
      <div
        class="price"
        fxLayoutAlign="start center"
        fxLayoutGap="8px"
        *ngIf="selectedCreditTab == 2"
      >
        <div
          [lnsAccountBalance]="accountData.annuity"
          class="price__value"
        ></div>
        <span class="price__currency">{{ accountData.currency }}</span>
      </div>
      <div
        class="price"
        fxLayoutAlign="start center"
        fxLayoutGap="8px"
        *ngIf="selectedCreditTab == 0"
      >
        <div
          [lnsAccountBalance]="accountData.balance[0]?.amount"
          class="price__value"
        ></div>
        <span class="price__currency">{{ accountData.currency }}</span>
      </div>
      <ng-container>
        <div class="font-14 text-gray mb-12 mt-n8">
          {{ 'payment_details_amount' | translate }}
        </div>
      </ng-container>
    </ng-container>

    <!-- SAVINGS_ACCOUNT -->
    <ng-container
      *ngIf="
        accountData.accountType.includes('SAVINGS_ACCOUNT') ||
        accountData.accountType.includes('SAVINGS_PROXY_ACCOUNT') ||
        accountData.accountType.includes('DEPOSIT_ACCOUNT') ||
        accountData.accountType.includes('GRADUAL_SAVINGS_ACCOUNT') ||
        accountData.accountType.includes('GRADUAL_SAVINGS_PROXY_ACCOUNT')
      "
    >
      <div
        class="currency"
        fxLayout="row"
        fxLayoutGap="10px"
        (wheel)="onLabelsScroll($event)"
        #labels
      >
        <ng-container>
          <p
            *ngFor="let balance of accountData.balances"
            [ngClass]="{
              'currency--active':
                accountData.activeBalance?.currency === balance.currency
            }"
            (click)="changeCurrency(balance)"
          >
            {{ balance.currency }}
          </p>
          <p
            *ngFor="let balance of accountData.balance"
            [ngClass]="{
              'currency--active':
                accountData.currency === balance.currency ||
                (accountData.activeBalance
                  ? accountData.activeBalance?.currency
                  : accountData.currency
                  ? accountData.currency
                  : accountData.balance[0].currency) === balance.currency
            }"
            (click)="changeCurrency(balance)"
          >
            {{ balance.currency }}
          </p>
        </ng-container>
      </div>

      <div class="price" fxLayoutAlign="start center" fxLayoutGap="8px">
        <div
          [lnsAccountBalance]="
            accountData.activeBalance
              ? accountData.activeBalance?.amount
              : accountData.totalAmount
              ? accountData.totalAmount
              : accountData.balance[0].amount
          "
          class="price__value"
        ></div>
        <span class="price__currency">{{
          accountData.activeBalance
            ? accountData.activeBalance?.currency
            : accountData.currency
            ? accountData.currency
            : accountData.balance[0].currency
        }}</span>
      </div>
      <div class="font-14 text-gray mb-12 mt-n8">
        {{ 'dashboard__account_available_balance' | translate }}
      </div>
    </ng-container>
  </ng-container>
</lns-card>
